const TRACKERS =  {
   PROJECT_EXPORTED: "Project-Exported",
   EXPORT_INITIATED: "Export-Initiated",
   EXPORT_BTN_YOUTUBE_CLICKED: "Export-Btn-Youtube-Clicked",
   EXPORT_BTN_DOWNLOAD_CLICKED: "Export-Btn-Download-Clicked",
   EXPORT_BTN_TIKTOK_CLICKED: "Export-Btn-TikTok-Clicked"
}

export default TRACKERS;